import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './routes';
import 'react-toastify/dist/ReactToastify.css';
import "./assets/styles/index.scss"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
